import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import InvoicePositionsPosition from '@/views/my-projects/components/invoice/positions/InvoicePositionsPosition.vue';
import { computed, ref } from 'vue';
import InvoicePositionsSum from '@/views/my-projects/components/invoice/positions/InvoicePositionsSum.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import useCurrency from '@/mixins/useCurrency';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePositions',
  setup(__props) {

const positions = ref([{
  amount: '5',
  unit: 'HOURS',
  unitPrice: '10.00',
  description: 'Tüdeleien und sowat all',
},
{
  amount: '3',
  unit: 'HOURS',
  unitPrice: '10.00',
  description: 'Noch mehr Gedöns',
},
]);

const { format: currencyFormat } = useCurrency();

const positionWithNetSum = (position:any) => ({
  ...position,
  netSum: `${currencyFormat((+position.amount * +position.unitPrice))} €`
});

const sum = computed(() => {
  const totalNet = positions.value.reduce((acc, cur) => acc + (+cur.amount * +cur.unitPrice), 0);
  const addedVAT = totalNet * 0.19; // @ todo: Use REAL VAT
  return {
    totalNet,
    addedVAT,
    totalAmount: totalNet + addedVAT,
  };
});

const onUpdatePosition = (i: number, position: any) => {
  positions.value.splice(i, 1, position);
};

const onRemovePosition = (i: number) => {
  positions.value.splice(i, 1);
};

const onAddPosition = () => {
  positions.value.push({
    amount: '1',
    unit: 'HOURS',
    unitPrice: '0.00',
    description: '',
  });
};


return { __sfc: true,positions, currencyFormat, positionWithNetSum, sum, onUpdatePosition, onRemovePosition, onAddPosition, InvoiceSection, InvoicePositionsPosition, InvoicePositionsSum, BCXButton }
}

})